import './textareafieldwrapper.css'

import { TextArea as KendoTextArea } from "@progress/kendo-react-inputs";
import {
    FieldWrapper,
} from "@progress/kendo-react-form";
import {
    Label,
} from "@progress/kendo-react-labels";
import { isNullOrEmpty, isObjectNull } from '../../helpers/ObjectHelpers';
import { CopyToClipboard } from '../CopyToClipboard';

function TextAreaFieldWrapper({
    title = "",
    value = "",
    rows = 6,
    canCopyToClipboard = true,
    onChange,
    disabled = false,
    boldTitle = false,
    className = "",
    readOnly = false,
    autoSize = false,
    isRequired = false,
    placeholder = "",
    language = ""
}) {

    return (
        <FieldWrapper>
            <Label className="k-form-label font-size-md">
                <div className="textarea-copy-to-clipboard">
                    {!isNullOrEmpty(title) &&
                        <div style={{
                            fontWeight: boldTitle ? "700" : "normal"
                        }}>
                            {title}: {isRequired ? <span className="textarea-required">*</span> : null}
                            {!isNullOrEmpty(language) && <span className={`fi fi-${language}`} style={{ marginLeft: 5, marginRight: 5 }} />}
                        </div>
                    }
                    <div>
                        {
                            (canCopyToClipboard && !isNullOrEmpty(value)) &&
                                <CopyToClipboard text={value}/>
                        }
                    </div>
                </div>

            </Label>
            <div className="k-form-field-wrap">
                <KendoTextArea
                    value={isNullOrEmpty(value) ? "" : value}
                    onChange={handleOnChange}
                    rows={rows}
                    autoSize={autoSize}
                    placeholder={placeholder ? `${placeholder}...` : `${title}...`}
                    className={`${className} font-size-lg`}
                    disabled={disabled}
                    readOnly={readOnly}
                />
            </div>
        </FieldWrapper>
    );

    function handleOnChange(e) {
        if (disabled || isObjectNull(onChange)) return;

        onChange(e);
    }
}

export default TextAreaFieldWrapper;
